import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import { ButtonBase, Grid } from '@material-ui/core'
import CopilotSettingItem from './CopilotSettingItem'
import CategoryIcons from './icons/CopilotSettings/CategoryIcons'
import AddCopilotSetting from './icons/CopilotSettings/AddCopilotSetting'

const useStyles = makeStyles(theme => ({
  addItemButton: {
    border: '1px solid rgba(219, 227, 244, 1)',
    borderRadius: 16,
    backgroundColor: 'white',
    height: 80,
    width: '160px',
    [theme.breakpoints.up('lg')]: {
      width: '160px'
    },
    [theme.breakpoints.up('xl')]: {
      width: '220px'
    }
  }
}))

const CopilotSettingsList = ({ categories, onOpenPatientBriefEditorClicked = () => {}, analyticsPayload = {} }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Grid container spacing={1}>
      {Object.values(categories).map(category => (
        <Grid item key={`copilot-setting-${category.key}`} className={classes.settingItem}>
          <CopilotSettingItem
            icon={React.createElement(CategoryIcons[category.key])}
            title={t(`pages.patients.patientSidebar.items.copilot.copilotSettings.categories.${category.key}.title`)}
            summary={category.summary}
            onClick={onOpenPatientBriefEditorClicked}
            categoryData={category}
            analyticsPayload={analyticsPayload}
          />
        </Grid>
      ))}
      <Grid item className={classes.settingItem}>
        <ButtonBase className={classes.addItemButton} onClick={onOpenPatientBriefEditorClicked}>
          <AddCopilotSetting />
        </ButtonBase>
      </Grid>
    </Grid>
  )
}

export default CopilotSettingsList
